import React from "react";
import { OutlinedInput } from "@mui/material";

import useEHRNotes from "./useEHRNotes";
import SubmitButton from "components/Button/SubmitButton";

import {
  cancelEHRNote,
  onEHRNoteChange,
  onEHRNoteInputFocus,
} from "app/store/transmission/slice/transmissionSlice";

const EHRNoteForm = ({ data, isFetching }) => {
  const {
    dispatch,
    handleEHRNote,
    currentEhrNote,
    ehrNoteFocused,
    ehrNoteSubmitting,
  } = useEHRNotes(data);

  return (
    <div className="view-pdf__notes-content">
      <OutlinedInput
        rows={3}
        multiline
        fullWidth
        className="view-pdf__notes-content--textarea"
        variant="outlined"
        id="standard-basic"
        data-text="ehr-note-field"
        placeholder="Add EHR Note"
        value={currentEhrNote?.note || ""}
        onChange={(event) => {
          dispatch(
            onEHRNoteChange({
              ...currentEhrNote,
              note: event.target.value,
            })
          );
        }}
        onFocus={() => dispatch(onEHRNoteInputFocus(true))}
      />
      {ehrNoteFocused && (
        <div className="view-pdf__button-container d-flex flex-column">
          <SubmitButton
            handleClick={handleEHRNote}
            className="view-pdf__button mb-2"
            variant="contained"
            color="secondary"
            data-action="ehr-save-button"
            disabled={
              !ehrNoteFocused ||
              !currentEhrNote?.note?.trim() ||
              isFetching ||
              ehrNoteSubmitting
            }
            isLoading={ehrNoteSubmitting}
            buttonText="Save"
          />
          <SubmitButton
            handleClick={() => dispatch(cancelEHRNote({ focused: false }))}
            className="view-pdf__button"
            variant="outlined"
            disabled={ehrNoteSubmitting}
            color="secondary"
            buttonText="Cancel"
            data-action="ehr-cancel-button"
          />
        </div>
      )}
    </div>
  );
};

export default EHRNoteForm;
